/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * GetSubscriptionDetails Input Action
 */
export class GetSubscriptionDetailsInput implements Msdyn365.IActionInput {
    constructor() {}

    public getCacheKey = () => `SubscriptionDetails ${new Date()}`;
    public getCacheObjectType = () => 'SubscriptionDetails';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSubscriptionDetailsData {
    ContactEmailAddress: string;
    ContactGivenName: string;
    ContactSurname: string;
    CreditCardNumber: string;
    CreditCardTypeName: string;
    CustomerReference: string;
    ScheduleNumber: string;
    PaymentMethod: string;
    LineNum: string;
    Status: number;
    PaymentFailed: boolean;
    PaymentLinkUrl: string;
    StartDate: string;
    EndDate: string;
    NextPaymentDate: string;
    LastOrderDate: string;
    SubscriptionAddressBillTo: ISubscriptionAddressBillTo;
    SubscriptionLineTotals: ISubscriptionLineTotals;
    SubscriptionRelatedInvoices: ISubscriptionRelatedInvoices[];
}

export interface ISubscriptionAddressBillTo {
    Name: string;
    FormattedAddress: string;
    ExtensionProperties: [];
}

export interface ISubscriptionLineTotals {
    CurrencyCode: string;
    Frequency: number;
    ItemName: string;
    Quantity: number;
    SubTotalAmount: number;
    TotalAmount: number;
    Unit: string;
    VATAmount: string;
    VATPercantage: string;
    ExtensionProperties: [];
}

export interface ISubscriptionRelatedInvoices {
    InvoiceCurrencyCode: string;
    InvoiceId: string;
    InvoiceTotalAmount: number;
    InvoicePaymentStatus: number;
    InvoiceDate: string;
    ExtensionProperties: [];
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetSubscriptionDetailsInput();
};

async function action(input: GetSubscriptionDetailsInput, ctx: Msdyn365.IActionContext): Promise<IGetSubscriptionDetailsData | undefined> {
    let subscriptionDetails: IGetSubscriptionDetailsData | undefined;

    const url = ctx.requestContext.url.requestUrl;
    const subscriptionId = url.searchParams.get('subBillBillingScheduleNumber');
    const lineId = url.searchParams.get('subBillLineNum');

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/TecGetSubscription(subBillBillingScheduleNumber='${subscriptionId}',subBillLineNum=${lineId})`,
        'get',
        {},
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            subscriptionDetails = res.data as IGetSubscriptionDetailsData;
        })
        .catch(ex => {
            console.log('Error', ex);
        });

    return subscriptionDetails;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSubscriptionDetailsData>>action,
    id: 'GetSubscriptionDetails',
    input: createInput
});
